<script lang="ts">
  export let txt: string,typeTxt:"text"|"input" = "text";

  let id = `cb-${txt}`,msg: string;

  function handleClick() {
    const cb: HTMLInputElement | null = document.getElementById(id);

    if (cb) {
      cb.type = "text";
      cb.select();

      try {
        msg = document.execCommand("copy")
          ? "Copié dans le presse-papier"
          : "Copie impossible !";
      } catch (err) {
        msg = "Oops, impossible de copier";
      }
      cb.type = "hidden";
      window.getSelection().removeAllRanges();
      setTimeout(() => (msg = null), 2000);
    }
  }
</script>

<div class="Clipboard">
  {#if typeTxt === "input"}
    <input class="Clipboard__input" value={txt} readOnly />
  {:else if typeTxt === "text" || !typeTxt}
    <span class="text">{txt}</span>
  {/if}
  <div
    on:click={handleClick}
    title="Copier dans le presse papier"
    class="Clipboard__icon"
  >
    <div class="cmd"><i class="fad fa-paste" /></div>
  </div>
  <input type="hidden" {id} value={txt} readOnly />
  {#if msg}
    <div class="Clipboard__msg">{msg}</div>
  {/if}
</div>

<style>
  .Clipboard {
    display: inline-grid;
    position: relative;
    grid-template-columns: 1fr auto;
    justify-content: center;
    align-items: center;
    grid-column-gap: 10px;
  }

  .Clipboard__msg {
    opacity: 0;
    background: green;
    color: white;
    padding: 3px;
    font-size: 0.9em;
    margin: 5px 0;
    position: absolute;
    white-space: nowrap;
    top: -40px;
    animation: bounce-in 1s 2 alternate;
  }

  .Clipboard__icon {
    cursor: pointer;
    transition: 200ms ease-in-out;
  }

  .Clipboard__icon:hover {
    transform: rotate(-5deg) scale(1.1);
  }

  .Clipboard__input {
    border: 1px solid #ddd;
    padding: 3px;
  }

  .cmd {
    font-size: 1.5em;
  }

  @keyframes bounce-in {
    0% {
      opacity: 0;
      border-radius: 50%;
      transform: translateY(45px);
    }

    25% {
      opacity: 1;
      border-radius: 0;
      transform: translateY(-5px);
    }

    50% {
      opacity: 1;
      border-radius: 0;
      transform: translateY(0);
    }

    100% {
      opacity: 1;
      border-radius: 0;
      transform: translateY(0);
    }
  }
</style>
